import GetQueryParam from '../util/get-query-param';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
class ArisePremium25Controller {
    constructor() {
        this.setSlider();
        this.setImgsParallax();
        this.setDesignImgs();
        this.setUnderSlider();
        this.setSctolltrigger();
        this.changeTab();
        this.setAnchor();

        window.addEventListener('popstate', () => {
            const q = new GetQueryParam();
            if (q.series) {
                $(`a.is-${q.series}`).trigger('click');
            } else {
                $('.style-arisepremium25__tab a').not('is-current').trigger('click');
            }
        });
    }

    setSlider() {
        let options = {
            loop: true,
            // loopAdditionalSlides: 1,
            loopFillGroupWithBlank: false,
            centeredSlides: true,
            // spaceBetween: window.UA.isSP ? 16 : 32,
            slidesPerView: 'auto',
            speed: 1400,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            touchAngle: 20,
            effect: 'fade',
            fadeEffect: {
                crossFade: false,
            },
            pagination: {
                el: '#js-style-arisepremium25__sec-slider-pagination',
                clickable: true,
                renderBullet: function (index, className) {
                    return `<div class="style-arisepremium25__sec-slider-pagination-bullet"><svg viewBox="0 0 15 15"><path  d="M0.5,7.5a7,7 0 1,0 14,0a7,7 0 1,0 -14,0" /></svg><span></span></div>`;
                },
                bulletClass: 'style-arisepremium25__sec-slider-pagination-bullet',
                bulletActiveClass: 'is-active',
            },
            on: {
                // onSlideChangeEnd : (s) => {s.fixLoop();}
            },
        };

        let slider = new Swiper('#js-style-arisepremium25__sec-slider', options);
        if (window.UA.isSP) {
            slider.off('resize');
        }
    }

    setImgsParallax() {
        $('.style-arisepremium25__sec-intro-img').each(function () {
            const $this = $(this);
            gsap.fromTo(
                $this.find('.style-arisepremium25__sec-intro-img-inner img'),
                { y: '-15%' },
                {
                    // y: (window.UA.isSP)? 40: 80,
                    y: '5%',
                    scrollTrigger: {
                        // markers: true,
                        trigger: $this,
                        start: 'top bottom',
                        // end: 'top top',
                        scrub: 1.6,
                        toggleActions: 'play none none reverse',
                        // onToggle: (self) => console.log('toggled, isActive:', self.isActive),
                    },
                },
            );
        });
    }

    setDesignImgs() {
        $('.style-arisepremium25__sec-design-box-imgs').each(function () {
            const $this = $(this);
            gsap.fromTo(
                $this.find('.style-arisepremium25__sec-design-box-img img'),
                { opacity: 0, scale: 1.03 },
                {
                    opacity: 1,
                    scale: 1,
                    stagger: 0.2,
                    scrollTrigger: {
                        // markers: true,
                        trigger: $this,
                        start: 'center bottom',
                        // end: 'bottom-=200',
                        // scrub: 1,
                        // toggleActions: 'play none none reverse',
                        // onToggle: (self) => console.log('toggled, isActive:', self.isActive),
                    },
                },
            );
        });
    }

    setUnderSlider() {
        let options = {
            loop: true,
            // loopAdditionalSlides: 4,
            loopFillGroupWithBlank: false,
            centeredSlides: window.UA.isSP ? false : true,
            spaceBetween: window.UA.isSP ? 32 : 56,
            slidesPerView: 'auto',
            speed: 1400,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            touchAngle: 20,
            // effect: 'fade',
            // fadeEffect: {
            //     crossFade: false
            // },
            pagination: {
                el: '#js-style-arisepremium25__sec-gallery-slide-pagination',
                clickable: true,
                renderBullet: function (index, className) {
                    return `<div class="style-arisepremium25__sec-gallery-slide-pagination-bullet"><svg viewBox="0 0 15 15"><path  d="M0.5,7.5a7,7 0 1,0 14,0a7,7 0 1,0 -14,0" /></svg><span></span></div>`;
                },
                bulletClass: 'style-arisepremium25__sec-gallery-slide-pagination-bullet',
                bulletActiveClass: 'is-active',
            },
            on: {
                // onSlideChangeEnd : (s) => {s.fixLoop();}
            },
        };

        let slider = new Swiper('#js-style-arisepremium25__sec-gallery-slide', options);
        if (window.UA.isSP) {
            slider.off('resize');
        }
    }

    setSctolltrigger() {
        $('.js-scroll-trigger-gsap').each(function () {
            const $this = $(this);
            gsap.fromTo(
                $this,
                { opacity: 0, scale: 1.03 },
                {
                    opacity: 1,
                    scale: 1,
                    scrollTrigger: {
                        // markers: true,
                        trigger: $this,
                        start: 'center bottom',
                        // end: 'bottom-=200',

                        // scrub: 1,
                        // toggleActions: 'play none none reverse',
                        // onToggle: (self) => console.log('toggled, isActive:', self.isActive),
                    },
                },
            );
        });
    }
    changeTab() {
        const $tab = $('.style-arisepremium25__tab a');
        const $wrapper = $('#js-style-arisepremium25__wrapper');
        const _this = this;
        // console.log(window.slideitem);
        $tab.each(function () {
            const $this = $(this);
            $this.on('click', function (e) {
                e.preventDefault();
                const target = $this.attr('href');
                // console.log(target);
                $wrapper.addClass('is-transition');
                fetch(target)
                    .then((res) => res.text())
                    .then((text) => {
                        const $sec = $(text).find('.style-arisepremium25__sec');
                        // console.log($sec.attr('id'));
                        setTimeout(() => {
                            $wrapper.empty().append($sec);
                            $tab.removeClass('is-current');
                            $this.addClass('is-current');
                            window.history.pushState({}, null, target);
                            _this.setSlider();
                            _this.setImgsParallax();
                            _this.setDesignImgs();
                            _this.setUnderSlider();
                            _this.setSctolltrigger();
                            _this.player = null;
                            _this.player = new YT.Player('js-popup__movie', {
                                videoId: $('#js-style-detail__movie-btn').data('yid'),
                            });
                            _this.setPopupMovie();
                            if($sec.attr('id') === 'stella') {
                                $('.is-otherslide-premium').empty().append(window.slideitem.otherBlanc);
                            }
                            if($sec.attr('id') === 'blanc') {
                                $('.is-otherslide-premium').empty().append(window.slideitem.otherStella);
                            }
                            
                            $wrapper.removeClass('is-transition');
                        }, 200);
                    });
            });
        });
    }
    setAnchor() {
        const q = new GetQueryParam();
        if (q.series) {
            setTimeout(() => {
                //trigger click
                // console.log( $(`a.is-${q.series}`));
                $('html, body')
                    .stop()
                    .animate(
                        {
                            scrollTop: $('.style-arisepremium25__tab').offset().top - $('#js-global-header').height(),
                        },
                        16,
                    );
            }, 200);
        }
    }

    setPopupMovie() {
        const $link = $('#js-style-detail__movie-btn');
        const $pop = $('.style-detail__movie-popup');
        const _this = this;
        $link.on('click', function (e) {
            e.preventDefault();
            $pop.toggleClass('is-open');
            _this.player.playVideo();
        });

        $pop.on('click', function (e) {
            e.preventDefault();
            // console.log(e.currentTarget);
            if ($(e.target).hasClass('is-open')) {
                $pop.removeClass('is-open');
                _this.player.pauseVideo();
            }
        });
        $('.common-popup__close').on('click', function (e) {
            e.preventDefault();
            $pop.removeClass('is-open');
            _this.player.pauseVideo();
        });
    }
}

export default ArisePremium25Controller;
